var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandContentwhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_1884",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14H7C7.28333 14 7.52083 14.0958 7.7125 14.2875C7.90417 14.4792 8 14.7167 8 15C8 15.2833 7.90417 15.5208 7.7125 15.7125C7.52083 15.9042 7.28333 16 7 16H3C2.71667 16 2.47917 15.9042 2.2875 15.7125C2.09583 15.5208 2 15.2833 2 15V11C2 10.7167 2.09583 10.4792 2.2875 10.2875C2.47917 10.0958 2.71667 10 3 10C3.28333 10 3.52083 10.0958 3.7125 10.2875C3.90417 10.4792 4 10.7167 4 11V14ZM14 4H11C10.7167 4 10.4792 3.90417 10.2875 3.7125C10.0958 3.52083 10 3.28333 10 3C10 2.71667 10.0958 2.47917 10.2875 2.2875C10.4792 2.09583 10.7167 2 11 2H15C15.2833 2 15.5208 2.09583 15.7125 2.2875C15.9042 2.47917 16 2.71667 16 3V7C16 7.28333 15.9042 7.52083 15.7125 7.7125C15.5208 7.90417 15.2833 8 15 8C14.7167 8 14.4792 7.90417 14.2875 7.7125C14.0958 7.52083 14 7.28333 14 7V4Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandContentwhite);
export default __webpack_public_path__ + "static/media/expand_content white.70d8c1e3f2ff5a2056f040fb798d8cf4.svg";
export { ForwardRef as ReactComponent };